import {
    AssuranceMultiriskImage,
    BankImage,
    CalendarImage,
    ComputerImage,
    EpargneImage,
    HandImage,
    HealthImage,
    IndustryImage,
    InsuranceVehicleImage,
    MachineImage,
    ProtectionImage,
    ResponsabilityCompanyImage,
    ResponsabilityCivilImage,
    ResponsabilityDecennalImage,
    PrevoyanceImage,
    PrevoyanceAgricoleImage,
    InsuranceEmprunteurImage,
    InsuranceAgricoleImage,
    InsuranceComputerImage,
    InsuranceOthersImage,
    RiskImage,
    VanneImage,
    VehicleAgricoleImage,
    VehicleImage,
} from 'components';
import { Image } from '@axa-fr-axion/utils';

export const ProductIcons: {[key: string]: Image } = {
    MRP: AssuranceMultiriskImage,
    RCPRO: ResponsabilityCompanyImage,
    RCDECENNALE: ResponsabilityDecennalImage,
    RCDIRIGEANT: ResponsabilityCivilImage,
    SANTEDIRIGEANT: HealthImage,
    PREVOYANCEDIRIGEANT: PrevoyanceImage,
    PREVOYANCEAGRICOLE: PrevoyanceAgricoleImage,
    EPARGNERETRAITEDIRIGEANT: EpargneImage,
    SANTESALARIES: HealthImage,
    PREVOYANCESALARIES: PrevoyanceImage,
    EPARGNERETRAITESALARIES: EpargneImage,
    PJPRO: ProtectionImage,
    AUTOPRO: InsuranceVehicleImage,
    EMPRUNTEUR: InsuranceEmprunteurImage,
    MULTIRISQUEINFO: InsuranceComputerImage,
    MULTIRISQUEAGRICOLE: InsuranceAgricoleImage,
    DIVERSIARD: InsuranceOthersImage,
    CREDIT: BankImage,
    FLOTTE: VehicleImage,
    BRISDEMACHINE: MachineImage,
    LOCATIONMATERIEL: HandImage,
    RISQUESENVIRONNEMENTAUX: RiskImage,
    RCTRANSPORT: InsuranceVehicleImage,
    MARCHANDISES: VanneImage,
    CYBERRISQUES: ComputerImage,
    ANNULATIONEVENEMENTS: CalendarImage,
    RISQUESINDUSTRIELS: IndustryImage,
    MATERIELAGRICOLE: VehicleAgricoleImage,
    PACKMICROENTREPRENEUR: ResponsabilityCompanyImage,
};
